"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step2Selectors = {
  COMMON: {
    FORM: '#step2_form',
    MODAL_FORM: '#step2modalForm',
    MODAL: '#GuestModal',
    CREDIT_BANK_MODAL: '#CreditBankModal',
    MODAL_EMAIL: '#step2-modal-email',
    MODAL_FORM_SERIALIZED: '#cart-form-serialized',
    DELIVERY: '#delivery',
    DELIVERY_EMAIL_INPUT: '#delivery_email',
    PAYMENT: '#payment',
    CONTINUE_AS_GUEST_BTN: '#continueAsGuest',
    LOGIN_WHEN_USER_IS_GUEST_BTN: '#login-when-user-is-guest',
    LAST_STEP_BTN: '.lastStepButton',
    LAST_STEP_BTN_FINAL: '.lastStepButtonFinal',
    ALLOW_GUEST_CHECKER: '#allowGuestContinue',
    SAVED_DELIVERY: '#cart_saved_delivery',
    WANT_INVOICE_CHECKBOX: '#want_invoice',
    WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX: '#want_another_delivery_address',
    COPY_INVOICE_BTN: '#step2-copy-invoice',
    COPY_ANOTHER_DELIVERY_ADRESSES_BTN: '#step2-copy-another_delivery',
    INVOICE_DATA: '#invoice-data',
    DELIVERY_TILE: '.method-delivery',
    DELIVERY_TILE_SALON: '#delivery_method_19',
    DELIVERY_TILE_KURIER: '#delivery_method_20',
    DELIVERY_RADIO: '#delivery .delivery_method_radio',
    SELECTED_DELIVERY_RADIO: '#delivery .delivery_method_radio:checked',
    PAYMENT_RADIO: '#payment .payment_method_radio',
    SELECTED_PAYMENT_RADIO: '#payment .payment_method_radio:checked',
    DELIVERY_RADIO_SALON: '#cart_delivery_method_19',
    DELIVERY_RADIO_KURIER: '#cart_delivery_method_20',
    PAYMENT_METHOD_PRZELEWY: '#cart_payment_method_8',
    ANOTHER_DELIVERY_ADDRESS_DATA: '#another-delivery-address-data',
    LIGHT_PRELOADER: '#light-preloader'
  },
  DELIVERY_FORM_FIELDS: {
    CART_SAVED_DELIVERY: '#cart_saved_delivery',
    DELIVERY_FIRST_NAME: '#delivery_first_name',
    DELIVERY_LAST_NAME: '#delivery_last_name',
    DELIVERY_STREET: '#delivery_street',
    DELIVERY_HNUMBER: '#delivery_hnumber',
    DELIVERY_LNUMBER: '#delivery_lnumber',
    DELIVERY_POSTAL: '#delivery_postal',
    DELIVERY_CITY: '#delivery_city',
    DELIVERY_PHONE: '#delivery_phone'
  },
  ANOTHER_DELIVERY_FORM_FIELDS: {
    CART_SAVED_DELIVERY: '#another_cart_saved_delivery',
    DELIVERY_FIRST_NAME: '#another_delivery_first_name',
    DELIVERY_LAST_NAME: '#another_delivery_last_name',
    DELIVERY_STREET: '#another_delivery_street',
    DELIVERY_HNUMBER: '#another_delivery_hnumber',
    DELIVERY_LNUMBER: '#another_delivery_lnumber',
    DELIVERY_POSTAL: '#another_delivery_postal',
    DELIVERY_CITY: '#another_delivery_city',
    DELIVERY_PHONE: '#another_delivery_phone',
    DELIVERY_EMAIL: '#another_delivery_email'
  },
  FORM_FIELDS_ERROR: {
    ID_INPUT: '#delivery_department_id-error'
  },
  DEPARTMENTS: {
    CHANGE_BTN: '#personal-departments-button',
    SUBMIT_BTN: '#personal-department-submit',
    MODAL_SELECT: '#personal-department-select',
    MODAL: '#DepartmentsModal',
    ADDRESS: '#personal-department-address',
    ADDRESS_DIV: '#personal-department-contener',
    ID_INPUT: '#cart_delivery_department_id',
    MAP_VOIVODESHIP: '#svg_poland_map a',
    MAP_VOIVODESHIP_LIST: '#department-map-list',
    MAP_VOIVODESHIP_LIST_ELEM: '#department-map-list .map-list-element'
  },
  PAYMENT_METHODS: {
    COD: 'input#cart_payment_method_4'
  },
  PARCEL_LOCKER: {
    MODAL: '#parcelLockerModal',
    SELECT_BUTTON: '#selectParcelLocker',
    SELECTED_LOCKER: '#selectedParcelLocker',
    SELECTED_LOCKER_TEXT: '.selected-parcel-locker-text',
    MAP_ELEMENT: 'map-element',
    MODAL_BACK: '.modal-backdrop',
    ERROR_MSG: '#inpost-error-message'
  }
};